import React from 'react'
import T from 'mrf/utils/T';
import tw, { styled } from "twin.macro";

const Variant = styled.span`
    ${({ color }) => color === 'error' && tw`text-xs italic tracking-wide text-error`}
`;

export default function Text({
    children,
    variant = 'span',
    ...props
}) {


    return (
        <Variant as={variant} {...props}>
            <T>{children}</T>
        </Variant>
    );
}
